import React from 'react';

import { VIDPTTypes, VIDTPTTypes } from './actions'


const initialState = {
    isFetching: false,
    data: null
}


export function VIDPartialContract(state = initialState, action) {

    switch(action.type) {

        case VIDPTTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            state.data = null
            return state
        case VIDPTTypes.RECEIVE:
            state = {...state}
            state.isFetching = false
            state.data = action.data
            return state
        case VIDPTTypes.ERROR:
            state = {...state}
            state.isFetching = false
            state.data = action.data
            return state

        default:
            return state
    }
}

export function VIDTPartialContract(state = initialState, action) {

    switch(action.type) {

        case VIDTPTTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            state.data = null
            return state
        case VIDTPTTypes.RECEIVE:
            state = {...state}
            state.isFetching = false
            state.data = action.data
            return state
        case VIDTPTTypes.ERROR:
            state = {...state}
            state.isFetching = false
            state.data = action.data
            return state

        default:
            return state
    }
}